// extracted by css-extract-rspack-plugin
export default {"spinnerContainer":"PlaygroundChatAvatar-module__spinnerContainer__Fzes7"};